import React from 'react';
import { SourceProps } from 'react-map-gl';
import GeoJsonLayer from './GeoJsonLayer';

type RouteLayerProps = {
	id: string;
	data: SourceProps['data'] | object | null;
	loading: boolean;
	lineColor?: string;
};

const RouteLayer = ({
	id,
	data,
	loading,
	lineColor = '#BF93E4',
}: RouteLayerProps) => (
	<GeoJsonLayer
		id={id}
		data={data}
		type="line"
		layerStyle={{
			layout: {
				'line-join': 'round',
			},
			paint: {
				'line-color': loading ? '#CCC' : lineColor,
				'line-width': 3,
			},
		}}
	/>
);

export default RouteLayer;
